import { Image } from 'antd';
import React, { FC } from 'react';
import { Company } from 'api/models';

interface CompanyLogoProps {
  data: Pick<Company, 'companyLogoUrl' | 'companyName'>;
}
export const CompanyLogo: FC<CompanyLogoProps> = ({ data }) => (
  <Image
    width={64}
    height={64}
    src={data.companyLogoUrl}
    preview={false}
    title={data.companyName}
    alt={data.companyName}
  />
);
